import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Divider, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from '../../store/userSlice';
import { CloseRounded } from '@mui/icons-material';
import CommentDrawer from '../../components/Common/Drawer';

export default function UserProfile({ getUsers, page, setPage, profileModal, setProfileModal, isShowRole = false, selectedUser = null }) {
    const [initialState, setiInitialState] = React.useState({});
    const userData = useSelector((state) => selectedUser ? selectedUser : state.userReducer?.userData)

    const rolesList = useSelector((state) => state.roleReducer.roleList)
    const dispatch = useDispatch()
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();

    const validationSchema = Yup.object({
        username: Yup.string()
            .required("Username is required")
            .min(3, "Username must be at least 3 characters"),
        email: Yup.string()
            .required("Email is required")
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "Enter a valid email address"
            ),
        role_id: Yup.string()
            .required("Role is required"),
    });

    const formik = useFormik({
        initialValues: initialState,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("Form Submitted:", values);
            values.uuid = userData?.uuid
            dispatch(updateUser(values)).then(() => {
                getUsers()
            })
            setProfileModal(false)
        },
    });

    useEffect(() => {
        if (userData) {
            setiInitialState({
                username: "",
                email: "",
                role_id: ""
            })
            formik.setFieldValue('username', userData?.username);
            formik.setFieldValue('email', userData?.email);
            formik.setFieldValue('role_id', userData?.role?.id);
        }
    }, [userData, profileModal])

    useEffect(() => {
        const disabled = JSON.stringify({
            'username': formik.values?.username,
            'email': formik.values?.email,
            'role_id': formik.values?.role_id
        }) === JSON.stringify({
            'username': userData?.username,
            'email': userData?.email,
            'role_id': userData?.role?.id
        });
        setIsButtonDisabled(disabled)
    }, [userData, formik.values])

    const handleClose = () => {
        setProfileModal(false);
    };

    return (
        <CommentDrawer open={profileModal} setOpen={handleClose} >

            <Box
                component="form"
                onSubmit={formik.handleSubmit}
            >
                <Grid item size={{ lg: 3, md: 6, sm: 12, xs: 12 }} >
                    <Typography variant="h6" gutterBottom className='p-3'>
                        Profile Info
                    </Typography>
                    <Divider />
                    <div className='role-form-scroller px-3' >
                        <TextField
                            fullWidth
                            required
                            id="userName"
                            name="userName"
                            label="User Name"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={true}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                            }}
                            error={formik.touched.username && Boolean(formik.errors.username)}
                            helperText={formik.touched.username && formik.errors.username}
                            InputLabelProps={{
                                shrink: Boolean(formik.values.username)
                            }}

                        />
                        <TextField
                            fullWidth
                            required
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.email}
                            // onChange={formik.handleChange}
                            onChange={(e) => {
                                const lowerCaseEmail = e.target.value.toLowerCase();
                                formik.setFieldValue("email", lowerCaseEmail);
                            }}
                            onBlur={formik.handleBlur}
                            // error={formik.touched.email && Boolean(formik.errors.email)}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                            InputLabelProps={{
                                shrink: Boolean(formik.values.username)
                            }}
                        />
                        {userData && formik?.values?.role_id ?

                            <FormControl fullWidth required className='mt-3'
                                error={formik.touched.role_id && Boolean(formik.errors.role_id)}
                            >
                                <InputLabel id="role_id">Role</InputLabel>
                                <Select
                                    labelId="role_id"
                                    id="role_id"
                                    name='role_id'
                                    label="Role"
                                    value={formik?.values?.role_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    MenuProps={{
                                        PaperProps: {
                                            className: "mui-select-menu",
                                        }
                                    }}
                                    endAdornment={
                                        formik?.values?.role_id ? (
                                            <IconButton
                                                size="small"
                                                className='mr-4'
                                                onClick={() => {
                                                    formik.setFieldValue('role_id', '');
                                                }}
                                                onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                            >
                                                <CloseRounded />
                                            </IconButton>
                                        ) : null
                                    }
                                >
                                    {rolesList?.length && rolesList?.map((ele) => <MenuItem value={ele.id}>{ele.name}</MenuItem>)}
                                </Select>
                                {formik.touched.role_id && formik.errors.role_id && (
                                    <FormHelperText className='text-danger'>{formik.errors.role}</FormHelperText>
                                )}

                            </FormControl> :
                            <FormControl
                                error={formik.touched.role_id && Boolean(formik.errors.role_id)}
                                required
                                fullWidth className='mt-3' >
                                <InputLabel id="role" >Role</InputLabel>
                                <Select
                                    labelId="role"
                                    id="role"
                                    name='role_id'
                                    label="Role"
                                    value={formik?.values?.role_id || ""}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    MenuProps={{
                                        PaperProps: {
                                            className: "mui-select-menu",
                                        }
                                    }}
                                    endAdornment={
                                        formik?.values?.role_id ? (
                                            <IconButton
                                                size="small"
                                                className='mr-4'
                                                onClick={() => {
                                                    formik.setFieldValue('role_id', '');
                                                    formik.setFieldTouched('role_id', false);
                                                }}
                                                onMouseDown={(event) => event.stopPropagation()} // Prevents the select dropdown from opening
                                            >
                                                <CloseRounded />
                                            </IconButton>
                                        ) : null
                                    }
                                >
                                    {(!rolesList || rolesList?.length === 0) && (
                                        <MenuItem disabled color="primary">
                                            No Role found.
                                        </MenuItem>
                                    )}
                                    {rolesList?.length && rolesList?.map((ele) => <MenuItem value={ele.id}>{ele.name}</MenuItem>)}
                                </Select>
                                {formik.touched.role_id && formik.errors.role_id && (
                                    <FormHelperText className='text-danger'>{formik.errors.role_id}</FormHelperText>
                                )}

                            </FormControl>}
                    </div>
                </Grid>
                <Box className="drawer-footer m-3" gap={2}>
                    <Button onClick={handleClose} className="mr-2" variant="outlined">Cancel</Button>
                    <Button type="submit" variant="contained" disabled={isButtonDisabled || !formik.isValid}>
                        Save
                    </Button>
                </Box>
            </Box>
        </CommentDrawer>
    )
}